<template>
  <base-section id="theme-features">
    <!--
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/images/BallstonBreachCrop.jpg')"
      class="pt-6 white--text"
      gradient="65deg, rgba(255, 255, 255, .1)  50%, rgba(5, 11, 31, .1)"
    >
    </v-img>
      We have a relatively broad set of concerns that impact Truro's climate, and realize that we can't focus on everything.  But our members are free to choose projects in any of these four areas, and create a new project or work with an existing project team to further our mission.

    -->
    <base-section-heading title="Our Concerns">
      Truro’s climate encompasses many elements, giving us a broad set of environmental concerns.  Although we can't focus on everything, our members are free to choose projects in any of these four areas creating a new project or working with an existing project team to further our mission.
    </base-section-heading>

    <v-container class="pb-0">
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
    </v-container>
    <span class="trace">ThemeFeatures.vue</span>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'Air',
          icon: 'mdi-cloud',
          html: '<b>The carbon dioxide (CO<sub>2</sub>) level in our air is increasing, mostly due to human CO<sub>2</sub> production as a biprodcut of industrial and residential activitiy.  Oil and propane furnaces, gasoline/diesel fueled vehicles, and electricity generation using fossil fuels all contribute to climate change.</b><br>',
          color: 'white',
        },
        {
          // color: 'primary',
          // dark: true,
          title: 'Land',
          icon: 'mdi-shovel',
          html: '<b>Our land supports food production and wildlife.  The foliage uses solar energy, water and CO<sub>2</sub> from the air and produces oxygen.  Plants have an important role in reducing climate change, and increasing the land area with plantings is key.</b><br><br>',
        },
        {
          title: 'Water',
          icon: 'mdi-water-pump',
          html: '<b>Over time, our water supply, which comes from the fresh water aquifer under the Outer Cape, is at risk due to rising sea levels over time. In the near term, it also faces risks due to chemicals, pollutants, and other runoff.</b><br><br><br><br><br>',
        },
        {
          title: 'Fire & Energy',
          icon: 'mdi-fireplace',
          html: '<b>Fire was essential to early human development.  We began by burning wood, then coal, then oil and gas.  But when these high-carbon fossil fuels are burned, CO<sub>2</sub> is released into the atmosphere, increasing climate change.  Instead of getting our energy by burning fossil fuels, we need to switch to renewable forms of electicity generation. And we also experience wild fires, on an increasing frequency.</b>',
        },
      ],
    }),
  }
</script>

<style scoped>
#theme-features {
    background-color: #eff;
    background: linear-gradient(to bottom, #E3F2FD, #64B5F6);
    /*   90caf9 */
}
</style>
